<formio-loader></formio-loader>
<div class="formio_dialog" [dir]="dir$ | async">
	<button type="button" class="btn-close btn-close-dialog" (click)="cancel()">
		<mat-icon>close</mat-icon>
	</button>
	<formio
		[formKey]="formKey"
		[submission]="submission"
		[readOnly]="dialogData.viewOnly"
		[viewOnly]="dialogData.viewOnly"
		(customEvent)="customEvent($event)"
		(beforeSubmit)="beforeSubmit($event)"
		(submit)="submit($event)"
	></formio>
</div>
